import "../../styles/studio/visualization/createVisualizationButton.css";
import ErrorToast from "../common/ErrorToast.jsx";

const CreateVisualizationButton = ({
  submitHandler,
  loading = false,
  error,
}) => {
  return (
    <div className="create-viz-btn-wrapper">
      <ErrorToast error={error} />

      <button
        type="button"
        className="create-viz-btn"
        onClick={submitHandler}
        disabled={loading}
      >
        {loading ? "Creating..." : "Create Visualization"}
      </button>
    </div>
  );
};

export default CreateVisualizationButton;
